export default "__VITE_ASSET__ZvTNOXTN__"